import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useSinglePlacementLayouts } from '@bingads-webui-campaign-react/ad-placement-factory';
import { evaluateAdCustomizers } from '@bingads-webui-campaign/ad-customizers-next';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getDomain } from '@bingads-webui/url-util';
import { combineDescriptions } from '@bingads-webui-campaign-react/ad-common';
import { getPreviewStyles } from './styles';

const adType = 'DynamicSearchAd';

const DSAPreviewGroupType = 'dynamicSearchAd';

const DynamicSearchAdPreviewUAPLUnstyled = ({
  classes,
  data: {
    Text,
    TextPart2,
    DisplayUrl,
    Path1,
    Path2,
  },
  domain,
}) => {
  const [description, setDescription] = useState('');
  const [urlPath1, setUrlPath1] = useState('');
  const [urlPath2, setUrlPath2] = useState('');

  const urlDomain = useMemo(() => getDomain(DisplayUrl) || domain, [DisplayUrl, domain]);
  const displayUrl = useMemo(() => `${urlDomain}${urlPath1}${urlPath2}`, [urlDomain, urlPath1, urlPath2]);
  const finalUrl = useMemo(() => `https://${displayUrl}`, [displayUrl]);

  const [{ SinglePlacementLayout }] = useSinglePlacementLayouts({
    groupType: DSAPreviewGroupType,
    placementFilterPredicate: tmp => tmp.type === adType,
  });

  useEffect(() => {
    evaluateAdCustomizers({
      adType,
      field: 'Descriptions',
      text: combineDescriptions(Text, TextPart2),
    }).then((evaluatedText) => {
      setDescription(evaluatedText);
    });
  }, [Text, TextPart2]);

  useEffect(() => {
    evaluateAdCustomizers({
      adType,
      field: 'Path1',
      text: Path1,
    }).then((evaluatedText) => {
      setUrlPath1(evaluatedText ? `/${evaluatedText}` : '');
    });
  }, [Path1]);

  useEffect(() => {
    evaluateAdCustomizers({
      adType,
      field: 'Path2',
      text: Path2,
    }).then((evaluatedText) => {
      setUrlPath2(evaluatedText ? `/${evaluatedText}` : '');
    });
  }, [Path2]);

  const adData = useMemo(() => ({
    description,
    finalUrl,
    displayUrl,
  }), [description, displayUrl, finalUrl]);

  return (
    <div className={classes.adPreviewContainer}>
      <SinglePlacementLayout adData={adData} />
    </div>
  );
};

DynamicSearchAdPreviewUAPLUnstyled.propTypes = {
  classes: PropTypes.shape({
    adPreviewContainer: PropTypes.string,
  }).isRequired,
  data: PropTypes.shape({
    Text: PropTypes.string,
    TextPart2: PropTypes.string,
    DisplayUrl: PropTypes.string,
    Path1: PropTypes.string,
    Path2: PropTypes.string,
  }),
  domain: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

DynamicSearchAdPreviewUAPLUnstyled.defaultProps = {
  data: {},
  domain: '',
};

export const DynamicSearchAdPreviewUAPL =
  withDefaultStyles(DynamicSearchAdPreviewUAPLUnstyled, getPreviewStyles);
